import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  URL: string;

  constructor(
    private http: HttpClient,
    private auth: AuthService
  ) {
    // this.URL = `${environment.baseServerURLOld}/company`;
    this.URL = `${environment.baseServerURL}/administration/bot`;
  }

  buildURL(subPath: string) {
    return `${this.URL}/${subPath}/${this.auth.user.company.id}`;
  }

  private webFetchURL(): string {
    return `${environment.baseServerURL}/orchestrator/tenant-config/${this.auth.user.company.id}/web-fetch`;
  }

  getBotSettings(): Observable<any> {
    return this.http.get(this.buildURL('settings'), {
      withCredentials: true
    });
  }

  updateBotSettings(settings): Observable<any> {
    return this.http.put(this.buildURL('settings'), settings, {
      withCredentials: true
    });
  }

  /**
   * The web-access flag the Agent Orchestrator actually reads on every turn. The bot's own
   * `agenticWebEnabled` is only this screen's copy, so the toggle shows this value.
   */
  getWebFetchConfig(): Observable<{ web_fetch_enabled: boolean }> {
    return this.http.get<{ web_fetch_enabled: boolean }>(this.webFetchURL(), {
      withCredentials: true
    });
  }

  updateWebFetchConfig(webFetchEnabled: boolean): Observable<{ web_fetch_enabled: boolean }> {
    const url = this.webFetchURL();
    return this.http.patch<{ web_fetch_enabled: boolean }>(url, {
      web_fetch_enabled: webFetchEnabled
    }, {
      withCredentials: true
    });
  }

  /***********************************************************************
   * PROMPT GPT IMPLEMENTATION
   */

  getPrompt(company: number): Observable<any> {
    const URL = `${environment.baseServerURL}/administration/company/${company}/getPrompt`;
    return this.http.get(URL, {
      withCredentials: true
    });
  }

  setPrompt(req: { prompt: string, company: number }): Observable<any> {
    const { prompt, company } = req;
    const URL = `${environment.baseServerURL}/administration/company/${company}/setPrompt`;
    return this.http.patch(URL, { prompt }, {
      withCredentials: true
    });
  }

}
